import { MessageService } from 'primeng/api';
import { Component } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputOtpModule } from 'primeng/inputotp';
import { AuthService } from '../../services/account/auth.service';
import { validateEmailResponse } from '../../models/account/validateEmailResponse';
@Component({
  selector: 'app-mentor-sign-up',
  standalone: true,
  imports: [
    InputTextModule,
    ButtonModule,
    RouterModule,
    CommonModule,
    FormsModule,
    InputOtpModule,
  ],
  templateUrl: './mentor-sign-up.component.html',
  styleUrl: './mentor-sign-up.component.scss',
})
export class MentorSignUpComponent {
  otpSent: boolean = false;
  loading: boolean = false;
  email: string = '';
  otp: string = '';

  constructor(
    private router: Router,
    private authService: AuthService,
    private messageService: MessageService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    //Using queryParams
    this.route.queryParams.subscribe((params) => {
      const email = params['email'];
      if (email) {
        this.email = email;
      }
    });
  }

  onSubmit(form: any) {
    this.loading = true;
    if (!this.otpSent) {
      this.authService.validateEmail(this.email).subscribe({
        next: (response: validateEmailResponse) => {
          if (response.isAccountExists) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `User already exist with ${this.email} email.Try with other email`,
            });
          } else {
            this.otpSent = true;
          }
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error,
          });
        },
        complete: () => {
          this.loading = false;
        },
      });
    }
    if (this.otpSent) {
      // Verify OTP
      this.authService
        .verifyOTP({
          email: this.email,
          oTP: this.otp,
        })
        .subscribe({
          next: (response) => {
            var token = response.temporaryToken ?? '';
            this.router.navigate(['/mentor-signup-steps'], {
              state: { token: token, email: this.email },
            });
            this.loading = false;
            return;
          },
          error: (error) => {
            this.messageService.add({
              severity: 'error',
              summary: error.name,
              detail: 'Invalid OTP! Try again',
            });
            this.loading = false;
            return;
          },
        });
    }
  }
}
